import styled, { css } from "styled-components"

export const BaseParagraph = styled.p`
  ${() => {
    return css`
      ${getFontStyles}
      ${getBoldStyles}
      ${getColorStyles}
      ${getMarginStyles}
      ${getTransformStyles}
      ${getTextAlignStyles}
    `
  }}
`

const getFontStyles = ({ theme, $size }) => {
  const { size, lineHeight, weight } = theme.fonts
  const { lineHeight: h2 } = theme.widgets.h2.fonts

  switch ($size) {
    case "xl":
      return css`
        font-size: ${size.xtraLargeParagraph};
      `
    case "large":
      return css`
        font-size: ${size.large};
        line-height: ${lineHeight.singleNThird};
      `
    case "small":
      return css`
        font-size: ${size.smallParagraph};
        line-height: ${lineHeight.singleNThird};
      `
    case "xs":
      return css`
        font-size: ${size.xtraSmallParagraph};
        line-height: ${lineHeight.double};
      `
    case "h2":
      return css`
        font-size: ${size.large};
        line-height: ${h2};
        font-weight: ${weight.regular};
        margin: unset;
      `
    default:
      return css`
        font-size: ${size.paragraph};
        line-height: ${lineHeight.singleNThird};
      `
  }
}

const getBoldStyles = ({ theme, $bold }) => {
  const { weight } = theme.fonts
  if ($bold) {
    return css`
      font-weight: ${weight.bold};
    `
  }
}

const getColorStyles = ({ theme, $color }) => {
  const { colors } = theme
  const { bg } = colors[$color] || colors["primary"]
  return css`
    color: ${bg};
  `
}

const getMarginStyles = ({ theme, $marginBottom, $marginTop, $marginLeft }) => {
  const { small, normal } = theme.spaces

  return css`
    margin-bottom: ${$marginBottom ? small : "0"};
    margin-top: ${$marginTop ? normal : "0"};
    margin-left: ${$marginLeft ? small : "0"};
  `
}

const getTransformStyles = ({ $transform }) => {
  if ($transform) {
    return css`
      text-transform: uppercase;
    `
  }
}
const getTextAlignStyles = ({ $textAlign }) => css`
  text-align: ${$textAlign};
`
